/**
 * FloatingDock — 하단 중앙에 떠있는 macOS Dock 풍 네비게이션.
 *
 * ui-thing.behonbaker.com/components/floating-dock 벤치. Framer Motion 없이 pure CSS
 * transform + hover tooltip 으로 가볍게 구현. 화면 전체를 main content 가 쓸 수 있도록
 * 기존 240px 사이드바를 대체한다.
 *
 * 사용처: App.tsx sidebar 교체.
 */
import { NavLink } from "react-router-dom"

export type DockItem = {
	readonly to?: string
	readonly href?: string
	readonly label: string
	readonly icon: React.ReactNode
	/** external link — 새 탭으로 열고 dock active 상태 계산 대상 아님 */
	readonly external?: boolean
	/** 버튼처럼 동작 (logout 등) */
	readonly onClick?: () => void
}

export function FloatingDock(props: {
	readonly items: ReadonlyArray<DockItem>
	readonly footer?: ReadonlyArray<DockItem>
}) {
	return (
		<nav className="floating-dock" aria-label="주요 네비게이션">
			{props.items.map((item) => (
				<DockButton key={item.label} item={item} />
			))}
			{props.footer && props.footer.length > 0 && (
				<>
					<span className="floating-dock__divider" aria-hidden />
					{props.footer.map((item) => (
						<DockButton key={item.label} item={item} />
					))}
				</>
			)}
		</nav>
	)
}

function DockButton({ item }: { readonly item: DockItem }) {
	const body = (
		<>
			{item.icon}
			<span className="floating-dock__tip">{item.label}</span>
		</>
	)

	if (item.onClick) {
		return (
			<button type="button" className="floating-dock__item" onClick={item.onClick} aria-label={item.label}>
				{body}
			</button>
		)
	}

	if (item.external && item.href) {
		return (
			<a
				className="floating-dock__item"
				href={item.href}
				target="_blank"
				rel="noopener noreferrer"
				aria-label={item.label}
			>
				{body}
			</a>
		)
	}

	if (item.to) {
		return (
			<NavLink
				to={item.to}
				className={({ isActive }) => `floating-dock__item${isActive ? " is-active" : ""}`}
				aria-label={item.label}
			>
				{body}
			</NavLink>
		)
	}

	return null
}
